import { render, staticRenderFns } from "./CompanyExtract.vue?vue&type=template&id=544bae58"
import script from "./CompanyExtract.vue?vue&type=script&lang=js"
export * from "./CompanyExtract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports